const filterOptions = (options, selected) => {
  return options.filter(option => {
    if (selected) {
      return option.selected
    }
    return !option.selected
  })
}

export default filterOptions
